<!-- <ib-input-error
  *ngIf="blockUiError"
  [customErrors]="'sce.' + blockUiError | transloco"
  class="mt-inp-hint-mt p-24px"
>
</ib-input-error>

<div [hidden]="blockUiError">
  <div [hidden]="isPhoneConfirmed">
    <form [formGroup]="parentForm">
      <mat-form-field>
        <mat-label>{{ 'comp.comfirm-sms.input-title' | transloco }}</mat-label>
        <input matInput hidden [formControl]="formCtrl" required />
        <div class="relative">
          <code-input
            #codeInput
            [isCodeHidden]="false"
            [code]="code"
            [initialFocusField]="0"
            [codeLength]="codeLength"
            [disabled]="
              checkCodeLoading ||
              disabled ||
              isCodeConfirmed ||
              isResendAvailable
            "
            (codeChanged)="codeError = undefined"
            (codeCompleted)="codeCompleted($event)"
          >
          </code-input>
          <ib-spinner
            *ngIf="checkCodeLoading"
            [fluid]="true"
            [diameter]="20"
          ></ib-spinner>
        </div>
      </mat-form-field>
    </form>

    <div
      [hidden]="isResendAvailable"
      class="ib-code-input-wrap --controls flex justify-between items-start"
    >
      <div>
        <ib-input-error
          *ngIf="codeError"
          [customErrors]="codeError"
          class="mt-inp-hint-mt"
        >
        </ib-input-error>

        <ib-tooltip
          *ngIf="isTooltipAvailable"
          [customTmpl]="tooltipTmpl"
          class="mt-inp-hint-mt"
        >
          <ng-template #tooltipTmpl>
            <ng-container>
              {{ 'comp.comfirm-sms.expire-in' | transloco }}&nbsp;<ib-time-diff
                [timestamp]="codeExpireAt"
                [intervalSec]="1"
              ></ib-time-diff>
            </ng-container>
          </ng-template>
        </ib-tooltip>
      </div>

      <button
        *ngIf="isClearAvailable"
        mat-button
        type="button"
        (click)="clearInput()"
        class="ib-btn ib-btn-link ib-btn-sm ib-btn-secondary mt-12px"
      >
        {{ 'btn.clear' | transloco }}&nbsp;{{ 'base.input' | transloco }}
      </button>
    </div>

    <div
      *ngIf="isResendAvailable"
      class="relative flex justify-center items-center text-12px text-txt mt-24px"
    >
      {{ 'comp.comfirm-sms.resend-msg' | transloco }}&nbsp;

      <ib-btn-wrap btnType="link" [isLoading]="sendCodeLoading">
        <button
          mat-button
          (click)="resendCode.emit()"
          type="button"
          [disabled]="sendCodeLoading"
          class="relative ib-btn ib-btn-link ib-btn-sm ib-btn-secondary"
        >
          {{ 'btn.resend' | transloco }}
        </button>
      </ib-btn-wrap>
    </div>
  </div>
  <div
    *ngIf="isCodeConfirmed"
    class="text-semibold capitalize-first flex justify-center items-center text-16px mt-24px p-16px shadow-wdgt rounded-wdgt"
  >
    <i class="text-success! material-icons mr-6px text-32px">check_circle</i>
    {{ 'base.phone' | transloco }}
    <span class="text-secondary">&nbsp;{{ phone }}&nbsp;</span>
    <span class="lowercase">{{ 'base.confirmed' | transloco }}</span>
  </div>
</div> -->
<ib-input-error
  *ngIf="blockUiError"
  [customErrors]="'sce.' + blockUiError | transloco"
  class="mt-inp-hint-mt p-24px"
>
</ib-input-error>

<div [hidden]="blockUiError">
  <div [hidden]="isPhoneConfirmed">
    <form [formGroup]="parentForm">
      <mat-form-field>
        <mat-label>{{ 'comp.comfirm-sms.input-title' | transloco }}</mat-label>
        <input matInput hidden [formControl]="formCtrl" required />
        <div class="relative">
          <code-input
            #codeInput
            [isCodeHidden]="false"
            [code]="code"
            [initialFocusField]="0"
            [codeLength]="codeLength"
            [disabled]="
              checkCodeLoading ||
              disabled ||
              isCodeConfirmed ||
              isResendAvailable
            "
            (codeChanged)="codeError = undefined"
            (codeCompleted)="codeCompleted($event)"
          >
          </code-input>
          <ib-spinner
            *ngIf="checkCodeLoading"
            [fluid]="true"
            [diameter]="20"
          ></ib-spinner>
        </div>
      </mat-form-field>
    </form>

    <div
      [hidden]="isResendAvailable"
      class="ib-code-input-wrap --controls flex justify-between items-start"
    >
      <div>
        <ib-input-error
          *ngIf="codeError"
          [customErrors]="codeError"
          class="mt-inp-hint-mt"
        >
        </ib-input-error>

        <ib-tooltip
          *ngIf="isTooltipAvailable"
          [customTmpl]="tooltipTmpl"
          class="mt-inp-hint-mt"
        >
          <ng-template #tooltipTmpl>
            <ng-container>
              {{ 'comp.comfirm-sms.expire-in' | transloco }}&nbsp;<ib-time-diff
                [timestamp]="codeExpireAt"
                [intervalSec]="1"
              ></ib-time-diff>
            </ng-container>
          </ng-template>
        </ib-tooltip>
      </div>

      <button
        *ngIf="isClearAvailable"
        mat-button
        type="button"
        (click)="clearInput()"
        class="ib-btn ib-btn-link ib-btn-sm ib-btn-secondary mt-12px"
      >
        {{ 'btn.clear' | transloco }}&nbsp;{{ 'base.input' | transloco }}
      </button>
    </div>

    <div
      *ngIf="isResendAvailable"
      class="relative flex justify-center items-center text-12px text-txt mt-24px"
    >
      {{ 'comp.comfirm-sms.resend-msg' | transloco }}&nbsp;

      <ib-btn-wrap btnType="link" [isLoading]="sendCodeLoading">
        <button
          mat-button
          (click)="resendCode.emit()"
          type="button"
          [disabled]="sendCodeLoading"
          class="relative ib-btn ib-btn-link ib-btn-sm ib-btn-secondary"
        >
          {{ 'btn.resend' | transloco }}
        </button>
      </ib-btn-wrap>
    </div>
  </div>
  <div
    *ngIf="isCodeConfirmed"
    class="text-semibold capitalize-first flex justify-center items-center text-16px mt-24px p-16px shadow-wdgt rounded-wdgt"
  >
    <i class="text-success! material-icons mr-6px text-32px">check_circle</i>
    {{ 'base.phone' | transloco }}
    <span class="text-secondary">&nbsp;{{ phone }}&nbsp;</span>
    <span class="lowercase">{{ 'base.confirmed' | transloco }}</span>
  </div>
</div>

